module.exports = __webpack_public_path__ + "static/media/engine_starting.c15a4151.svg";